export default __webpack_public_path__ + "0402a814.jpg";